<template>
  <div class="paginator">
    <div class="md-layout ">

      <div class="md-layout-item">
        <md-button @click="type = 'student'" class="assessment-type " :class="type == 'student' ? 'md-primary md-raised' : ''">
          <md-icon>event</md-icon>
          <div>Student</div>
        </md-button>
      </div>
      <div class="md-layout-item">
        <md-button @click="type = 'resident'" class="assessment-type " :class="type == 'resident' ? 'md-primary md-raised' : ''">
          <md-icon>date_range</md-icon>
          <div>Resident</div>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssessmentUserTypeSelect",
  props: ['value'],
  data() {
    return {
      type: this.value ? this.value : 'student'
    }
  },
  watch: {
    type() {
      this.$emit('input', this.type)
    }
  }
}
</script>